import * as React from "react";
import InlineCard from "./InlineCard";
import preloadedCards from "./preloadedCards";
import { useTranslation } from "./i18n";
var TrumpDisplay = function (_a) {
    var trump = _a.trump;
    var t = useTranslation().t;
    if ("Standard" in trump) {
        var _b = trump.Standard, suit_1 = _b.suit, rank_1 = _b.number;
        var match = preloadedCards.find(function (v) { return v.typ === suit_1 && v.number === rank_1; });
        return (React.createElement("span", { className: "flex items-center gap-1" },
            match ? React.createElement(InlineCard, { card: match.value }) : suit_1,
            React.createElement("span", { className: "text-[var(--text-secondary)]" },
                "\u00B7 ",
                rank_1)));
    }
    else if (trump.NoTrump.number !== undefined &&
        trump.NoTrump.number !== null) {
        return (React.createElement("span", null,
            t("term.noTrump"),
            " \u00B7 ",
            trump.NoTrump.number));
    }
    else {
        return React.createElement("span", null, t("term.noTrump"));
    }
};
var Cell = function (props) { return (React.createElement("div", { className: "flex min-w-[6rem] flex-col" },
    React.createElement("span", { className: "text-[0.7rem] font-semibold uppercase tracking-wide text-[var(--text-secondary)]" }, props.label),
    React.createElement("span", { className: "text-base font-semibold " +
            (props.highlight
                ? "text-[var(--accent)]"
                : "text-[var(--text-primary)]") }, props.children))); };
/*
 * Compact status rail summarizing the live game state: trump suit + level,
 * declarer, current points, and whose turn it is. Labels are localized via
 * i18n (English in English mode, Chinese in Chinese mode). Rendered above the
 * trick area on the in-game table.
 */
var StatusRail = function (props) {
    var _a, _b;
    var t = useTranslation().t;
    return (React.createElement("div", { className: "sj-rail mb-4 flex flex-wrap items-center gap-x-6 gap-y-3 p-3" },
        React.createElement(Cell, { label: t("rail.trump") },
            React.createElement(TrumpDisplay, { trump: props.trump })),
        React.createElement(Cell, { label: t("rail.declarer") }, (_a = props.declarerName) !== null && _a !== void 0 ? _a : "—"),
        React.createElement(Cell, { label: t("rail.points") }, props.points),
        React.createElement(Cell, { label: t("rail.turn"), highlight: props.isYourTurn }, props.isYourTurn ? t("rail.yourTurn") : ((_b = props.turnName) !== null && _b !== void 0 ? _b : "—"))));
};
export default StatusRail;
